const state = () => ({
  points: []
});

const getters = {
  points: state => {
    return state.points;
  }
};

const actions = {
  async fetchPoints({ commit }, { id }) {
    const { data } = await this.$http.get(`/points/${id}`);
    commit(
      "setPoints",
      data.filter(d => d.plan_id != 0).filter(p => ![51, 52].includes(p.status))
    );
  }
};

const mutations = {
  setPoints(state, data) {
    state.points = data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
